import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SecuritymenuService } from '../../services/securitymenu.service';
import { Subject } from 'rxjs/Subject';
import { BaseService } from '../../base.service';
/*import { ExcelService } from '../../services/excel.service';*/

class Options {
  id: number;
  parentId: number;
  name: string;
  order: string;
  icon: string;
  href: string;
}

@Component({
  selector: 'app-system-options',
  templateUrl: './system-options.component.html',
  styleUrls: []
})
export class SystemOptionsComponent implements OnInit {

  options: Options[] = [];
  title_component: string;
  title_panel: string;
  name: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private securitymenuService: SecuritymenuService,
    private baseService: BaseService,
    /*private excelService: ExcelService*/
  ) {}

  ngOnInit(): any {
    this.title_component = 'Opciones de Sistema';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Lista de opciones de sistema';

    this.securitymenuService.getAll()
    .subscribe(data => {
      if (data) {
        const rutas = [];
        data.forEach(function (link) {
            if (link.status === true) {
                rutas.push(link.systemOption);
            }
        });
        this.options = rutas;
      }
    });
  }

  exportExcel() {
    /*this.excelService.exportAsExcelFile(this.options, 'files');*/
  }

  onChange($event, brand) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/system-options/system-options.component.ts